import React from "react";
import Reveal from "./Reveal";
import { Check, ArrowRight } from "lucide-react";
import { LINKS, CHECKOUT_RADIOGRAFIA_49 } from "@/lib/content";

const ITEMS = [
  "Diagnóstico claro de la situación actual.",
  "Principales fugas de tiempo, ventas y margen.",
  "Prioridades de mejora.",
  "Experimento recomendado para 7-30 días.",
  "Primer mapa de automatización si procede.",
];

const Offer = () => {
  return (
    <section
      id="oferta"
      data-testid="offer-section"
      className="et-section relative"
      style={{
        background:
          "linear-gradient(180deg, transparent 0%, rgba(19,40,61,0.55) 50%, transparent 100%)",
      }}
    >
      <div className="et-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          {/* Left header */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="et-eyebrow">La oferta</div>
            </Reveal>

            <Reveal delay={0.08}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
                Qué incluye{" "}
                <span className="et-text-gold">la Radiografía</span> de Negocio.
              </h2>
            </Reveal>

            {/* Core methodology phrase — prominent */}
            <Reveal delay={0.16}>
              <div
                className="mt-6 et-glass rounded-2xl px-5 py-4"
                data-testid="offer-methodology"
              >
                <p className="text-base md:text-lg text-white font-semibold tracking-tight leading-snug">
                  Primero claridad.{" "}
                  <span className="text-[#f5f2ea]/95 font-normal">Luego sistema.</span>{" "}
                  <span className="et-text-gold">Después, si toca, IA.</span>
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.24}>
              <p className="mt-6 text-base md:text-lg text-[#f5f2ea]/90 leading-relaxed">
                No es una auditoría para llenar un PDF. Es una{" "}
                <span className="text-white font-semibold">
                  herramienta para decidir
                </span>{" "}
                qué hacer primero.
              </p>
            </Reveal>

            <Reveal delay={0.32}>
              <a
                href={CHECKOUT_RADIOGRAFIA_49}
                target={CHECKOUT_RADIOGRAFIA_49.startsWith("http") ? "_top" : undefined}
                data-testid="offer-cta"
                className="et-btn-primary mt-7"
              >
                Hacer mi Radiografía por 49 €
                <ArrowRight className="w-4 h-4" />
              </a>
            </Reveal>
          </div>

          {/* Right checklist */}
          <Reveal delay={0.18} className="lg:col-span-7">
            <div
              className="et-card !p-7 md:!p-9"
              style={{
                background:
                  "linear-gradient(180deg, rgba(19,40,61,0.85) 0%, rgba(16,32,46,0.7) 100%)",
              }}
            >
              <ul className="space-y-5">
                {ITEMS.map((item, i) => (
                  <li
                    key={item}
                    className="flex items-start gap-4 pb-5 border-b border-[#c5a059]/15 last:border-0 last:pb-0"
                    data-testid={`offer-item-${i}`}
                  >
                    <span
                      className="shrink-0 w-9 h-9 rounded-full grid place-items-center mt-0.5"
                      style={{
                        background: "rgba(197,160,89,0.14)",
                        border: "1px solid rgba(197,160,89,0.4)",
                      }}
                    >
                      <Check className="w-4 h-4 text-[#c5a059]" />
                    </span>
                    <p className="text-base md:text-lg text-white leading-relaxed">
                      {item}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Offer;
